// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Button_Button__RNcTG {
    font-size: 0.8rem;
    align-self: center;
    border-radius: 25px;
    border-color: transparent;
    padding: 0px 10px;
    margin-left: 2px;
    margin-right: 2px;
  }
  
  .Button_Button__RNcTG:hover {
    border-color: transparent !important;
    cursor: pointer;
  }

  .Button_Button__RNcTG:active {
    border-color: #000 !important;
    background-color: #0f6270 !important;
  }
  
  .Button_Button__RNcTG:focus {
    border-color: #000 !important;
    background-color: #0f6270 !important;
  }

  .Button_ButtonS__KRZUC {
    font-size: 0.6rem;
    align-self: center;
    border-radius: 25px;
    border-color: transparent;
    padding: 0px 10px;
    margin-left: 2px;
    margin-right: 2px;
  }
  
  .Button_ButtonS__KRZUC:hover {
    border-color: transparent !important;
    cursor: pointer;
  }

  .Button_ButtonS__KRZUC:active {
    border-color: #000 !important;
    background-color: #0f6270 !important;
  }
  
  .Button_ButtonS__KRZUC:focus {
    border-color: #000 !important;
    background-color: #0f6270 !important;
  }

.Button_ButtonB__qUB\\+X {
    font-size: 0.8rem;
    align-self: center;
    border-radius: 25px;
    border-color: transparent;
    padding: 0px 10px;
    margin-left: 2px;
    margin-right: 2px;
  }
  
  .Button_ButtonB__qUB\\+X:hover {
    border-color: transparent !important;
    cursor: pointer;
  }

  .Button_ButtonB__qUB\\+X:active {
    border-color: #000 !important;
    background-color: #0f6270 !important;
  }
  
  .Button_ButtonB__qUB\\+X:focus {
    border-color: #000 !important;
    background-color: #0f6270 !important;
  }

  .Button_ButtonTrack__B\\+6aS {
    padding: 4px 20px;
    font-size: 0.8rem;
    align-self: center;
    border-color: transparent;
    margin-left: 2px;
    margin-right: 2px;
  }
  
  .Button_ButtonTrack__B\\+6aS:hover {
    border-color: transparent !important;
    cursor: pointer;
  }

  .Button_ButtonTrack__B\\+6aS:active {
    border-color: transparent !important;
    background-color: #0f6270 !important;
  }
  
  .Button_ButtonTrack__B\\+6aS:focus {
    border-color: transparent !important;
    background-color: #0f6270 !important;
  }

  .Button_Home1__kPgeX {
    background-color: #052668;
    background-color: #05105d;
    background-color: #43606a;
    background-color: #39606e;
    color: #ffffff;
  }

  .Button_Blue__0XiDR {
    background-color: #26ded8;
    /* background-color: #05105d; */
    color: #ffffff;
  }

  .Button_Blue__0XiDR:hover {
    background-color: #40c0c7;
    color: #ffffff;
  }

.Button_Track__pw7\\+s {
    background-color: #24acc3;
    border: 1px solid rgba(74, 56, 1, 0.99);
    color: #fff;
}

.Button_Track__pw7\\+s:hover {
  background-color: #0f6270;
  color: #fff;
}

.Button_GreyDarkTrack__1jBzw {
    background-color: #43606a;
    border: 1px solid rgba(74, 56, 1, 0.99);
    color: #fff;
  }

  .Button_GreyDarkTrack__1jBzw:hover {
    background-color: #2f454c;
    border: 2px solid rgba(129, 102, 21, 0.99);
    color: #fff;
  }

.Button_Shed__-QITd {
    background-color: #24acc3;
    color: #fff;
  }

  .Button_Shed__-QITd:hover {
    background-color: #0f6270;
    color: #fff;
  }

  .Button_Shed2__QOYcK {
    background-color: #0095a3;
    color: #fff;
  }

  .Button_Shed2__QOYcK:hover {
    background-color: #0f6270;
    color: #fff;
  }
  
  .Button_Bright__LKElx {
    background-color: #24acc3;
    color: #fff;
  }

  .Button_Bright__LKElx:hover {
    background-color: #0f6270;
    color: #fff;
  }

  .Button_Back__sPVPf {
    background-color: rgb(33, 205, 239);
  }

  .Button_Back__sPVPf:hover {
    background-color: #32c0e4;
    color: #fff;
  }

  .Button_Once__6OfqO {
    background-color: grey;
    color: #000;
  }

  .Button_Once__6OfqO:hover {
    background-color: red;
    color: #fff;
  }

  .Button_CrewEdit__lJSOo {
    background-color: #59c1d2;
    color: #fff;
  }

  .Button_CrewEdit__lJSOo:hover {
    background-color: #0f6270;
    color: #fff;
  }

  .Button_Grey__S56D6 {
    background-color: #58666b;
    color: #fff;
  }

  .Button_Grey__S56D6:hover {
    background-color: #39606e;
    color: #fff;
  }

  .Button_GreyDark__VhGCf {
    background-color: #43606a;
    color: #fff;
  }

  .Button_GreyDark__VhGCf:hover {
    background-color: #0f6270;
    color: #fff;
  }

  .Button_GreyBlue__TxSKU {
    background-color: #39606e;
    color: #fff;
  }

  .Button_GreyBlue__TxSKU:hover {
    background-color: #0f6270;
    color: #fff;
  }

  .Button_White__jjHiL {
    background-color: #fafafa;
    color: #353839;
    font-weight: 900;
  }

  .Button_White__jjHiL:hover {
    background-color: #000;
    color: #fff;
  }

  .Button_BlackP__UiF4p {
    background-color: #3b444b;
    color: #fff;
    font-weight: 700;
    }

  .Button_BlackP__UiF4p:hover {
    background-color: #fff;
    color: #000;
  }

  .Button_Order__p5GhO {
    background-color: #000;
    color: #fff;
  }

  .Button_Order__p5GhO:hover {
    background-color: #0f6270;
    color: #fff;
  }

  .Button_OrderNN__3kBKD {
     background-color: #000;
    color: #fff;
  }

  .Button_OrderNN__3kBKD:hover {
    background-color: #0c3d65;
    color: #fff;
  }

  .Button_OrderN__O1pLm {
    background-color: #24acc3;
    color: #fff;
  }

  .Button_OrderN__O1pLm:hover {
    background-color: #0c3d65;
    color: #fff;
  }

  .Button_OrderS__f356c {
    background-color: #780770;
    color: #fff;
    cursor: pointer;
  }

  .Button_OrderS__f356c:hover {
    background-color: #480644;
    color: #fff;
  }

  .Button_Red__qli6U {
    background-color: crimson;
    color: #fff;
  }

  .Button_Red__qli6U:hover {
    background-color: #000;
    color: #fff;
  }

   .Button_RedDark__etiZm {
    background-color: rgb(187, 5, 41);
    color: #fff;
  }

  .Button_RedDark__etiZm:hover {
    background-color: #000;
    color: #fff;
  }

  .Button_BlueLight__D7Cpp {
    background: rgb(232, 240, 254);
    color: #000;
    font-weight: 700;
}
  
  .Button_Gold__sw6HU {
    background: rgba(129, 102, 21, 0.99);
    color: #fff;
    font-weight: 700;
}

.Button_Gold__sw6HU:hover {
    background: rgb(71, 68, 68);
    color: rgb(232, 240, 254);
    font-weight: 700;
    text-decoration: none;
}
  
  .Button_Wide__YY0FG {
    padding: 10px 50px;
    width: 50%;
  }

  .Button_WideTrack__vIL80 {
    width: 20%;
    font-size: 1rem;
  }

  .Button_Wide2__Knirq {
    width: 30%;
    /* font-size: 1rem; */
  }

  .Button_Wide3__-NNtB {
    padding: 2px 10px;
    width: 90%;
  }

  .Button_Wide4__Dm7u0 {
    padding: 4px 4px;
    width: 50%;
    font-size: 1rem;
  }

  .Button_Wide5__dXm3l {
    width: 100%;
  }

  .Button_WideChar__n1rnU {
    width: 25%;
  }

   @media screen and (max-width: 1100px) {
    .Button_WideTrack__vIL80 {
    width: 30%;
  }
   }

   @media screen and (max-width: 720px) {
    .Button_WideTrack__vIL80 {
    width: 50%;
  }
   }

  @media screen and (max-width: 600px) {
    .Button_Button__RNcTG {
    font-size: 0.6rem;
  }

  .Button_ButtonB__qUB\\+X {
    font-size: 0.6rem;
  }

  .Button_WideChar__n1rnU {
      width: 50%;
    }

    .Button_Wide2__Knirq {
      width: 50%;
    }
  }

  @media screen and (max-width: 343px) {

  .Button_Button__RNcTG {
    font-size: 0.5rem;
    border-color: transparent;
    padding: 0px 5px;
    margin-left: 0px;
    margin-right: 0px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Button.module.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,oCAAoC;IACpC,eAAe;EACjB;;EAEA;IACE,6BAA6B;IAC7B,oCAAoC;EACtC;;EAEA;IACE,6BAA6B;IAC7B,oCAAoC;EACtC;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,oCAAoC;IACpC,eAAe;EACjB;;EAEA;IACE,6BAA6B;IAC7B,oCAAoC;EACtC;;EAEA;IACE,6BAA6B;IAC7B,oCAAoC;EACtC;;AAEF;IACI,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,oCAAoC;IACpC,eAAe;EACjB;;EAEA;IACE,6BAA6B;IAC7B,oCAAoC;EACtC;;EAEA;IACE,6BAA6B;IAC7B,oCAAoC;EACtC;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,oCAAoC;IACpC,eAAe;EACjB;;EAEA;IACE,oCAAoC;IACpC,oCAAoC;EACtC;;EAEA;IACE,oCAAoC;IACpC,oCAAoC;EACtC;;EAEA;IACE,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,+BAA+B;IAC/B,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;AAEF;IACI,yBAAyB;IACzB,uCAAuC;IACvC,WAAW;AACf;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;IACI,yBAAyB;IACzB,uCAAuC;IACvC,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,0CAA0C;IAC1C,WAAW;EACb;;AAEF;IACI,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,qBAAqB;IACrB,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB;;EAEF;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;KACG,sBAAsB;IACvB,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;GAEC;IACC,iCAAiC;IACjC,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,8BAA8B;IAC9B,WAAW;IACX,gBAAgB;AACpB;;EAEE;IACE,oCAAoC;IACpC,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,yBAAyB;IACzB,gBAAgB;IAChB,qBAAqB;AACzB;;EAEE;IACE,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;GAEC;IACC;IACA,UAAU;EACZ;GACC;;GAEA;IACC;IACA,UAAU;EACZ;GACC;;EAED;IACE;IACA,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;MACI,UAAU;IACZ;;IAEA;MACE,UAAU;IACZ;EACF;;EAEA;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;EACnB;AACF","sourcesContent":[".Button {\n    font-size: 0.8rem;\n    align-self: center;\n    border-radius: 25px;\n    border-color: transparent;\n    padding: 0px 10px;\n    margin-left: 2px;\n    margin-right: 2px;\n  }\n  \n  .Button:hover {\n    border-color: transparent !important;\n    cursor: pointer;\n  }\n\n  .Button:active {\n    border-color: #000 !important;\n    background-color: #0f6270 !important;\n  }\n  \n  .Button:focus {\n    border-color: #000 !important;\n    background-color: #0f6270 !important;\n  }\n\n  .ButtonS {\n    font-size: 0.6rem;\n    align-self: center;\n    border-radius: 25px;\n    border-color: transparent;\n    padding: 0px 10px;\n    margin-left: 2px;\n    margin-right: 2px;\n  }\n  \n  .ButtonS:hover {\n    border-color: transparent !important;\n    cursor: pointer;\n  }\n\n  .ButtonS:active {\n    border-color: #000 !important;\n    background-color: #0f6270 !important;\n  }\n  \n  .ButtonS:focus {\n    border-color: #000 !important;\n    background-color: #0f6270 !important;\n  }\n\n.ButtonB {\n    font-size: 0.8rem;\n    align-self: center;\n    border-radius: 25px;\n    border-color: transparent;\n    padding: 0px 10px;\n    margin-left: 2px;\n    margin-right: 2px;\n  }\n  \n  .ButtonB:hover {\n    border-color: transparent !important;\n    cursor: pointer;\n  }\n\n  .ButtonB:active {\n    border-color: #000 !important;\n    background-color: #0f6270 !important;\n  }\n  \n  .ButtonB:focus {\n    border-color: #000 !important;\n    background-color: #0f6270 !important;\n  }\n\n  .ButtonTrack {\n    padding: 4px 20px;\n    font-size: 0.8rem;\n    align-self: center;\n    border-color: transparent;\n    margin-left: 2px;\n    margin-right: 2px;\n  }\n  \n  .ButtonTrack:hover {\n    border-color: transparent !important;\n    cursor: pointer;\n  }\n\n  .ButtonTrack:active {\n    border-color: transparent !important;\n    background-color: #0f6270 !important;\n  }\n  \n  .ButtonTrack:focus {\n    border-color: transparent !important;\n    background-color: #0f6270 !important;\n  }\n\n  .Home1 {\n    background-color: #052668;\n    background-color: #05105d;\n    background-color: #43606a;\n    background-color: #39606e;\n    color: #ffffff;\n  }\n\n  .Blue {\n    background-color: #26ded8;\n    /* background-color: #05105d; */\n    color: #ffffff;\n  }\n\n  .Blue:hover {\n    background-color: #40c0c7;\n    color: #ffffff;\n  }\n\n.Track {\n    background-color: #24acc3;\n    border: 1px solid rgba(74, 56, 1, 0.99);\n    color: #fff;\n}\n\n.Track:hover {\n  background-color: #0f6270;\n  color: #fff;\n}\n\n.GreyDarkTrack {\n    background-color: #43606a;\n    border: 1px solid rgba(74, 56, 1, 0.99);\n    color: #fff;\n  }\n\n  .GreyDarkTrack:hover {\n    background-color: #2f454c;\n    border: 2px solid rgba(129, 102, 21, 0.99);\n    color: #fff;\n  }\n\n.Shed {\n    background-color: #24acc3;\n    color: #fff;\n  }\n\n  .Shed:hover {\n    background-color: #0f6270;\n    color: #fff;\n  }\n\n  .Shed2 {\n    background-color: #0095a3;\n    color: #fff;\n  }\n\n  .Shed2:hover {\n    background-color: #0f6270;\n    color: #fff;\n  }\n  \n  .Bright {\n    background-color: #24acc3;\n    color: #fff;\n  }\n\n  .Bright:hover {\n    background-color: #0f6270;\n    color: #fff;\n  }\n\n  .Back {\n    background-color: rgb(33, 205, 239);\n  }\n\n  .Back:hover {\n    background-color: #32c0e4;\n    color: #fff;\n  }\n\n  .Once {\n    background-color: grey;\n    color: #000;\n  }\n\n  .Once:hover {\n    background-color: red;\n    color: #fff;\n  }\n\n  .CrewEdit {\n    background-color: #59c1d2;\n    color: #fff;\n  }\n\n  .CrewEdit:hover {\n    background-color: #0f6270;\n    color: #fff;\n  }\n\n  .Grey {\n    background-color: #58666b;\n    color: #fff;\n  }\n\n  .Grey:hover {\n    background-color: #39606e;\n    color: #fff;\n  }\n\n  .GreyDark {\n    background-color: #43606a;\n    color: #fff;\n  }\n\n  .GreyDark:hover {\n    background-color: #0f6270;\n    color: #fff;\n  }\n\n  .GreyBlue {\n    background-color: #39606e;\n    color: #fff;\n  }\n\n  .GreyBlue:hover {\n    background-color: #0f6270;\n    color: #fff;\n  }\n\n  .White {\n    background-color: #fafafa;\n    color: #353839;\n    font-weight: 900;\n  }\n\n  .White:hover {\n    background-color: #000;\n    color: #fff;\n  }\n\n  .BlackP {\n    background-color: #3b444b;\n    color: #fff;\n    font-weight: 700;\n    }\n\n  .BlackP:hover {\n    background-color: #fff;\n    color: #000;\n  }\n\n  .Order {\n    background-color: #000;\n    color: #fff;\n  }\n\n  .Order:hover {\n    background-color: #0f6270;\n    color: #fff;\n  }\n\n  .OrderNN {\n     background-color: #000;\n    color: #fff;\n  }\n\n  .OrderNN:hover {\n    background-color: #0c3d65;\n    color: #fff;\n  }\n\n  .OrderN {\n    background-color: #24acc3;\n    color: #fff;\n  }\n\n  .OrderN:hover {\n    background-color: #0c3d65;\n    color: #fff;\n  }\n\n  .OrderS {\n    background-color: #780770;\n    color: #fff;\n    cursor: pointer;\n  }\n\n  .OrderS:hover {\n    background-color: #480644;\n    color: #fff;\n  }\n\n  .Red {\n    background-color: crimson;\n    color: #fff;\n  }\n\n  .Red:hover {\n    background-color: #000;\n    color: #fff;\n  }\n\n   .RedDark {\n    background-color: rgb(187, 5, 41);\n    color: #fff;\n  }\n\n  .RedDark:hover {\n    background-color: #000;\n    color: #fff;\n  }\n\n  .BlueLight {\n    background: rgb(232, 240, 254);\n    color: #000;\n    font-weight: 700;\n}\n  \n  .Gold {\n    background: rgba(129, 102, 21, 0.99);\n    color: #fff;\n    font-weight: 700;\n}\n\n.Gold:hover {\n    background: rgb(71, 68, 68);\n    color: rgb(232, 240, 254);\n    font-weight: 700;\n    text-decoration: none;\n}\n  \n  .Wide {\n    padding: 10px 50px;\n    width: 50%;\n  }\n\n  .WideTrack {\n    width: 20%;\n    font-size: 1rem;\n  }\n\n  .Wide2 {\n    width: 30%;\n    /* font-size: 1rem; */\n  }\n\n  .Wide3 {\n    padding: 2px 10px;\n    width: 90%;\n  }\n\n  .Wide4 {\n    padding: 4px 4px;\n    width: 50%;\n    font-size: 1rem;\n  }\n\n  .Wide5 {\n    width: 100%;\n  }\n\n  .WideChar {\n    width: 25%;\n  }\n\n   @media screen and (max-width: 1100px) {\n    .WideTrack {\n    width: 30%;\n  }\n   }\n\n   @media screen and (max-width: 720px) {\n    .WideTrack {\n    width: 50%;\n  }\n   }\n\n  @media screen and (max-width: 600px) {\n    .Button {\n    font-size: 0.6rem;\n  }\n\n  .ButtonB {\n    font-size: 0.6rem;\n  }\n\n  .WideChar {\n      width: 50%;\n    }\n\n    .Wide2 {\n      width: 50%;\n    }\n  }\n\n  @media screen and (max-width: 343px) {\n\n  .Button {\n    font-size: 0.5rem;\n    border-color: transparent;\n    padding: 0px 5px;\n    margin-left: 0px;\n    margin-right: 0px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Button": `Button_Button__RNcTG`,
	"ButtonS": `Button_ButtonS__KRZUC`,
	"ButtonB": `Button_ButtonB__qUB+X`,
	"ButtonTrack": `Button_ButtonTrack__B+6aS`,
	"Home1": `Button_Home1__kPgeX`,
	"Blue": `Button_Blue__0XiDR`,
	"Track": `Button_Track__pw7+s`,
	"GreyDarkTrack": `Button_GreyDarkTrack__1jBzw`,
	"Shed": `Button_Shed__-QITd`,
	"Shed2": `Button_Shed2__QOYcK`,
	"Bright": `Button_Bright__LKElx`,
	"Back": `Button_Back__sPVPf`,
	"Once": `Button_Once__6OfqO`,
	"CrewEdit": `Button_CrewEdit__lJSOo`,
	"Grey": `Button_Grey__S56D6`,
	"GreyDark": `Button_GreyDark__VhGCf`,
	"GreyBlue": `Button_GreyBlue__TxSKU`,
	"White": `Button_White__jjHiL`,
	"BlackP": `Button_BlackP__UiF4p`,
	"Order": `Button_Order__p5GhO`,
	"OrderNN": `Button_OrderNN__3kBKD`,
	"OrderN": `Button_OrderN__O1pLm`,
	"OrderS": `Button_OrderS__f356c`,
	"Red": `Button_Red__qli6U`,
	"RedDark": `Button_RedDark__etiZm`,
	"BlueLight": `Button_BlueLight__D7Cpp`,
	"Gold": `Button_Gold__sw6HU`,
	"Wide": `Button_Wide__YY0FG`,
	"WideTrack": `Button_WideTrack__vIL80`,
	"Wide2": `Button_Wide2__Knirq`,
	"Wide3": `Button_Wide3__-NNtB`,
	"Wide4": `Button_Wide4__Dm7u0`,
	"Wide5": `Button_Wide5__dXm3l`,
	"WideChar": `Button_WideChar__n1rnU`
};
export default ___CSS_LOADER_EXPORT___;
